import {observer} from "mobx-react"
import {ReactNode} from "react"
import {DialogStoreInterface} from "../../store"
import * as ui from "@kroschke/react-ui"

interface DialogAction {
    label: string,
    execute: () => Promise<any>,
    className?: string,
    executing?: boolean,
}

interface ModalProps {
    store: DialogStoreInterface,
    closeOnBackgroundClick?: boolean,
    children?: ReactNode,
    title?: ReactNode,
    id?: string,
    titleCloseable?: boolean,
    disabledBodyPadding?: boolean,
    actions: DialogAction[]
}

const ModalDialog = observer(function ModalDialog({
                                                      closeOnBackgroundClick,
                                                      children,
                                                      id,
                                                      title,
                                                      titleCloseable,
                                                      store,
                                                      disabledBodyPadding,
                                                      actions
                                                  }: ModalProps) {
    return <ui.ModalDialog
        open={store.dialogOpen}
        close={() => store.dialogOpen = false}
        actions={actions}
        closeOnBackgroundClick={closeOnBackgroundClick}
        id={id}
        title={title}
        titleCloseable={titleCloseable}
        disabledBodyPadding={disabledBodyPadding}
    >
        {children}
    </ui.ModalDialog>
})

export {
    ModalDialog
}
